import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useTranslation } from 'react-i18next';

const { FiCheckCircle, FiTarget, FiShield, FiTrendingUp, FiAward, FiGlobe } = FiIcons;

const About = () => {
  const { t } = useTranslation();

  const values = [
    { icon: FiAward, title: 'Professionalità', description: 'Approccio metodico e standard di lusso in ogni fase della gestione.' },
    { icon: FiTrendingUp, title: 'Data Driven', description: 'Utilizziamo algoritmi avanzati per ottimizzare i prezzi ogni giorno.' },
    { icon: FiShield, title: 'Affidabilità', description: 'Gestione completa delle emergenze e manutenzione h24.' }
  ];

  return (
    <div className="pt-16">
      <section className="bg-gradient-to-br from-brand-blue/5 to-white py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} className="mb-8 flex justify-center">
            <img src="https://i.imghippo.com/files/DqZX5957Q.png" alt="Castello SRL" className="h-32 w-auto" />
          </motion.div>
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-4xl md:text-6xl font-black text-brand-blue mb-6">
            L'Eccellenza di <span className="text-brand-gold">Castello SRL</span>
          </motion.h1>
          <p className="text-xl text-brand-subtle max-w-3xl mx-auto leading-relaxed">
            Siamo una società specializzata nella valorizzazione e gestione di immobili di lusso e turistici, con l'obiettivo di trasformare ogni proprietà in un investimento ad alto rendimento.
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }}>
              <h2 className="text-3xl font-bold text-brand-blue mb-6">La Nostra Visione</h2>
              <p className="text-lg text-brand-subtle mb-6">
                Castello SRL nasce dalla necessità di professionalizzare il mercato degli affitti brevi in Italia. Non offriamo solo una gestione, ma un partner strategico per il tuo patrimonio immobiliare.
              </p>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiTarget} className="text-brand-gold h-6 w-6" />
                  <span className="font-bold text-brand-blue">Massimizzazione del ROI</span>
                </div>
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiGlobe} className="text-brand-gold h-6 w-6" />
                  <span className="font-bold text-brand-blue">Operativi in tutta Italia</span>
                </div>
              </div>
            </motion.div>
            <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-brand-silver/20">
              <img src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=800&q=80" alt="Castello SRL Luxury Property" className="w-full h-[400px] object-cover" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-brand-blue/5 text-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold mb-16 text-brand-blue uppercase tracking-widest">I Nostri Valori Cardine</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {values.map((v, i) => (
              <div key={i} className="bg-white p-10 rounded-2xl shadow-lg border border-brand-silver/10 hover:border-brand-gold/50 transition-all">
                <SafeIcon icon={v.icon} className="h-12 w-12 text-brand-gold mx-auto mb-6" />
                <h3 className="text-xl font-bold mb-4 text-brand-blue">{v.title}</h3>
                <p className="text-brand-subtle">{v.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;